import { x } from '@xstyled/styled-components';
import React, { DragEventHandler, FC, useEffect, useMemo } from 'react';
import {
  LeftMatchItem,
  RightMatchItem,
  useQuizMatchStore
} from '../QuizMatchStore';
import { CorrectBadge } from './CorrectBadge';
import { IncorrectBadge } from './IncorrectBadge';
import { LeftMatch } from './LeftMatch';
import { RightBorder } from './RightBorder';
import { RightShape, DropBox } from './RightShape';
import { useColor } from './useColor';
import audioEffectRightAnswer from '~/assets/mp3/right_answer.mp3';
import audioEffectWrongAnswer from '~/assets/mp3/wrong_answer.mp3';
import { useAudioEffect } from '~/ui/audio-effect/useAudioEffect';

export const RightMatch: FC<RightMatchItem> = ({ label, pairId, leftItem }) => {
  const match = useQuizMatchStore(s => s.match);
  const unSelect = useQuizMatchStore(s => s.unSelect);
  const correct = useMemo(() => {
    if (leftItem) return pairId === leftItem.pairId;
  }, [leftItem]);
  const color = useColor(correct);
  const dragOverHandler: DragEventHandler<HTMLDivElement> = e => {
    e.preventDefault();
  };

  const [playAudioEffectRightAnswer] = useAudioEffect(audioEffectRightAnswer);
  const [playAudioEffectWrongAnswer] = useAudioEffect(audioEffectWrongAnswer);

  useEffect(() => {
    if (correct !== undefined) {
      correct ? playAudioEffectRightAnswer() : playAudioEffectWrongAnswer();
    }
  }, [correct]);

  const dropHandler: DragEventHandler<HTMLDivElement> = e => {
    e.preventDefault();
    try {
      const dataTransferText = e.dataTransfer.getData('text/plain');
      if (!dataTransferText) {
        return;
      }
      const draggedData = JSON.parse(dataTransferText);
      match(pairId, draggedData);
    } catch (error) {
      // Silently ignore invalid drag data to prevent Sentry errors
    }
  };

  const onDoubleClick = (id: string, item: LeftMatchItem) => {
    unSelect(id, item);
  };

  return (
    <RightBorder highlightColor={color}>
      {correct === true ? (
        <CorrectBadge position="absolute" top="0" right="0" />
      ) : (
        ''
      )}
      {correct === false ? (
        <IncorrectBadge position="absolute" top="0" right="0" />
      ) : (
        ''
      )}{' '}
      <DropBox
        onDragOver={dragOverHandler}
        onDrop={dropHandler}
        onDoubleClick={() => onDoubleClick(pairId, leftItem as LeftMatchItem)}
      >
        <RightShape>
          {leftItem && (
            <x.div position="absolute" right="100%" cursor="pointer">
              <LeftMatch {...leftItem} correct={leftItem.pairId === pairId} />
            </x.div>
          )}
          {label}
        </RightShape>
      </DropBox>
    </RightBorder>
  );
};
